import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { day: "Sunday", Revenue: 450, Sales: 310, Profit: 280 },
  { day: "Monday", Revenue: 500, Sales: 260, Profit: 400 },
  { day: "Tuesday", Revenue: 420, Sales: 390, Profit: 360 },
  { day: "Wednesday", Revenue: 520, Sales: 450, Profit: 510 },
  { day: "Thursday", Revenue: 220, Sales: 180, Profit: 160 },
  { day: "Friday", Revenue: 400, Sales: 350, Profit: 370 },
  { day: "Saturday", Revenue: 200, Sales: 380, Profit: 150 },
];

export default function WeeklySalesChart() {
  return (
    <div
      style={{
        height: 400,
        background: "#fff",
        padding: "25px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
      }}
    >
      <h3 style={{ marginBottom: 20, color: "#333" }}>Weekly Stock Report</h3>

      <ResponsiveContainer width="100%" height="85%">
        <BarChart data={data}>
          <XAxis dataKey="day" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Revenue" fill="#2ec9d3" />
          <Bar dataKey="Sales" fill="#0b2b4c" />
          <Bar dataKey="Profit" fill="#e5e7eb" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
